import React from 'react';

import classNames from 'classnames';
import PhoneInput from 'react-phone-input-2';

import cls from './PhoneInput.module.css';
import 'react-phone-input-2/lib/style.css';
import './PhoneInput.css';

interface PhoneInputProps {
    inputName: string;
    label: string;
    placeholder: string;
    onChange: (name: string, value: string) => void;
    value: string;
    errorMessage?: string;
    classes?: string;
    type?: string;
    isMoney?: boolean;
    maxLength?: number;
}

export const PhoneInputs: React.FC<PhoneInputProps> = ({
    inputName,
    label,
    placeholder,
    onChange,
    value,
    errorMessage,
    classes,
}) => (
    <label className={classNames(cls.label, classes)}>
        {label}
        <PhoneInput
            value={value}
            onChange={(val) => onChange(inputName, val ? `+${val}` : '')}
            disableDropdown
            country=""
            inputProps={{
                name: inputName,
                placeholder,
            }}
            inputClass={cls.Input}
            containerClass={cls.phoneInputNoFlag}
            specialLabel=""
        />
        {errorMessage && <span className="error">{errorMessage}</span>}
    </label>
);
